<div [formGroup]="parentForm">
  <wsd-extended-input label="{{ showLabel ? (label | translate) : '' }}"
                     [control]="parentForm.get(controlName)">
    <p-autoComplete [formControlName]="controlName"
                    placeholder="{{ showPlaceholder ? (placeholder | translate) : '' }}"
                    [suggestions]="persons"
                    [minLength]="1"
                    field=fullName
                    dataKey="id"
                    [forceSelection]="true"
                    (completeMethod)="filterPersons($event)"
                    (onSelect)="onSelectValue($event)">
      <ng-template let-item pTemplate="item">
        <div class="item-container">
          <div>
        <span *ngIf="item.firstName !== null" class="m-r-5">{{ item.firstName}}</span>
        <span *ngIf="item.lastName !== null">{{ item.lastName}}</span>
          </div>
          <div>
        <span *ngIf="item.scoutOrgId !== null && fromAll">{{'ADD_APPOINTMENT_DIALOG.SCOUT_ID' | translate }} : {{ item.scoutOrgId}}</span>
          </div>
        </div>
      </ng-template>
      <!-- In multiple mode, selected item can be customized using selectedItem ng-template.
       Note that this template is not supported in single mode. -->
      <!--<ng-template let-item pTemplate="selectedItem">-->
        <!--{{ item.firstName + ' ' + item.lastName}}-->
      <!--</ng-template>-->
    </p-autoComplete>
  </wsd-extended-input>
</div>
